import React from 'react'
import T from 'prop-types'
import { Link, Paper, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const classes = {
  hasHandleClick: 'has-handle-click',
}
const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.hasHandleClick}:hover`]: {
    borderColor: theme.palette.text.primary,
  },
}))

export default function ChoiceRecap({
  id,
  title,
  value = '',
  titleProps,
  valueProps,
  handleClick,
  border = false,
  selected = false,
  sx,
  readOnly = false,
}) {
  return (
    <Link
      data-testid={`choice-recap-${id}`}
      underline="none"
      onClick={handleClick}
      sx={{ cursor: handleClick ? 'pointer' : undefined, ...sx }}
    >
      <StyledPaper
        variant={border ? 'outlined' : undefined}
        elevation={0}
        className={handleClick ? classes.hasHandleClick : undefined}
        sx={{
          py: 0.5,
          px: 1.5,
          minWidth: 60,
          borderColor: border && selected ? 'text.primary' : undefined,
        }}
      >
        <Typography
          variant="caption"
          component="p"
          color="textSecondary"
          {...titleProps}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          color="textPrimary"
          {...valueProps}
        >
          {value}
        </Typography>
      </StyledPaper>
    </Link>
  )
}

ChoiceRecap.propTypes = {
  title: T.string.isRequired,
  value: T.oneOfType([T.number, T.string]),
  titleProps: T.object,
  valueProps: T.object,
  handleClick: T.func,
  border: T.bool,
  selected: T.bool,
  sx: T.object,
  readOnly: T.bool,
}
